// ###########################################################################
// HEADER - Add class .min to scroll down
$(document).ready(function() {
  $(window).scroll(function() {
    var scrollPosition = $(window).scrollTop();

    if (scrollPosition > 300) {
      $('.main-header').addClass('min');
    } else {
      $('.main-header').removeClass('min');
    }
  });
});

// ###########################################################################
// ANIMATION FADE TO TOP - element dom
var $animation_elements = $('.animated');
var $window = $(window);

function check_if_in_view() {
    var window_height = $window.height();
    var window_top_position = $window.scrollTop();
    var window_bottom_position = (window_top_position + window_height);

    $.each($animation_elements, function() {
        var $element = $(this);
        var element_height = $element.outerHeight();
        var element_top_position = $element.offset().top;
        var element_bottom_position = (element_top_position + element_height);

        if ((element_bottom_position >= window_top_position) &&
            (element_top_position <= window_bottom_position)) {
            $element.addClass('active');
        }
    });
}

$window.on('scroll resize', check_if_in_view);
$window.trigger('scroll');

// ###########################################################################
// PRIMARY NAVIGATION
$("#btnMobile").click(function (e) {
  $(this).toggleClass("cross");
  $(".main-nav-wrapper").toggleClass("open");
  $("body").toggleClass("overflow");
});

// ###########################################################################
// SUBNAV NAVIGATION
$("ul > li.menu-item-has-children > a").click(function (e) {
    e.preventDefault();
    var LiParent =$(this).parent().attr('class');
    if(! LiParent.includes("openSub-menu") ){
        $('ul > li.menu-item-has-children > a').parent().removeClass("openSub-menu");
    }
    $(this).parent().toggleClass("openSub-menu");
});

// CLOSE NAV WHEN CLICK ANYWHERE
$(document).on("click", function (event) {
    var $trigger = $(".menu-item-has-children");
    if ($trigger !== event.target && !$trigger.has(event.target).length) {
        $(".menu-item-has-children").removeClass("openSub-menu");
    }
});

// ###########################################################################
// ANCRE
$('a[href^="#"]').on('click',function (e) {
    e.preventDefault();

    var nav = $('nav');
    var target = this.hash,
    $target = $(target);

    $('html, body').stop().animate({
        'scrollTop': $target.offset().top - nav.height()
    }, 1200, 'swing', function () {
        window.location.hash = target;
    });
});

// ###########################################################################
// HOMEPAGE - Animation paralax - block intro
$(window).on('scroll', function() {
    var scrollY = $(this).scrollTop();

    // Détection mobile
    var isMobile = window.innerWidth < 768;

    // Vitesse ajustée
    var speed1 = isMobile ? 0.05 : 0.2;
    var speed2 = isMobile ? 0.07 : 0.1;
    var speed3 = isMobile ? 0.1  : 0.3;
    var decoSpeed1 = isMobile ? -0.02 : -0.1;
    var decoSpeed2 = isMobile ? -0.05 : -0.4;
    var decoSpeed3 = isMobile ? -0.03 : -0.2;

    // Images
    $('.box__b01 > div').css('transform', 'translateY(' + scrollY * speed1 + 'px)');
    $('.box__b02 > div:nth-child(1)').css('transform', 'translateY(' + scrollY * speed2 + 'px)');
    $('.box__b02 > div:nth-child(2)').css('transform', 'translateY(' + scrollY * speed1 + 'px)');
    $('.box__b03 > div').css('transform', 'translateY(' + scrollY * speed3 + 'px)');

    // Déco
    $('.box > .deco_01').css('transform', 'translateY(' - scrollY * decoSpeed1  + 'px)');
    $('.box > .deco_01').css('transform', 'translateY(' - scrollY * decoSpeed2  + 'px)');
    $('.box > .deco_01').css('transform', 'translateY(' - scrollY * decoSpeed3 + 'px)');
    $('.box > .deco_01').css('transform', 'translateY(' - scrollY * decoSpeed3  + 'px)');
});

// ###########################################################################
// SLICK - slideshow & slider
// ✅ PROTÉGÉ: initialiser SEULEMENT si Slick existe
if (typeof $.fn.slick !== 'undefined') {
  $(document).ready(function(){

    $('.slideshow .slider-wrapper').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      infinite: true,
      speed: 1000,
    });

    $('.missions-slider .missions-items').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          }
        },
      ]
    });

    $('.project-slider .projects-grid').slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      autoplay: true,
      autoplaySpeed: 4000,
      arrows : false,
      dots: true,
      infinite: true,
    });

  });
}